export default __webpack_public_path__ + "static/markshade-535258ff52923c277fbdaa1abd559c31.png";